import { useDispatch, useSelector } from "react-redux"
import data, { urlapi } from "../../lib/backend/data"
import { useEffect, useRef, useState } from "react"
import { cerrarSesion } from "../../redux/actions/sesion"
import { Button, Checkbox, Col, Collapse, Form, Input, Modal, Pagination, Popconfirm, Rate, Row, Select, Switch, Table, Tabs, Tag, message } from "antd"
import CargandoTabla from "./cargando"
import Column from "antd/es/table/Column"
import Title from "antd/es/typography/Title"
import { fechaATextoSimple, fechaUTCATiempo, formatYMD_UTC } from "../../lib/helpers/helpers"
import { FileExcelFilled, SearchOutlined } from "@ant-design/icons"
import { encontrarLlaveValorEnEsquema } from "../../lib/helpers/interfaz"
import PersonalizarColumnas from "../../subComponents/interfaz/columnas_personalizar"
import EncabezadoPesonalizado from "../../subComponents/general/tablas/encabezado"
import { PiCursorClickFill } from 'react-icons/pi'
import ModalPersonalizado from "../../subComponents/general/modales/modal_personalizado"
import GraficosCamposPersonalizados from "../../subComponents/graficos/conductores"
import { obtenerFechaHoraZonaHorariaLocal } from "../../lib/helpers/dates"
import HelperModal from "../../subComponents/general/helperModal"
import { modulo, tipos_disponibilidad } from "./data"
import TagSinDatos from "../../subComponents/general/tag_sin_datos"
import SelectorZonaAvanzadoInternacional from "../RadioOperacion/selector_zona_avanzado_internacional"
import { IoCloseSharp } from "react-icons/io5"
import { FaAngleDown, FaAngleUp, FaCheckCircle, FaRegCalendar, FaRegCalendarAlt, FaRegTrashAlt } from "react-icons/fa"
import { DateTime } from "luxon"
import ModalSeleccionVehiculo from "../Vehiculos/modal_seleccion"
import ModalSeleccionTiposVehiculos from "../../subComponents/vehiculos/tipos/modal_seleccion_tipo"
import ModalSeleccionRequisitos from "../Requisitos/modal_seleccion"
import { GrAdd } from "react-icons/gr"
import VerContactoRapido from "./previsualizar"
import ListadoVehiculos from "../Vehiculos/listado"
import AgendaDisponibilidad from "./agenda_disponibilidad"
import { FaTruckFront } from "react-icons/fa6"
import { IoIosSend } from "react-icons/io"
import { rutas } from "../../lib/routes/routes"
import ListadoCalificaciones from "../Calificaciones/listado"
import { estilo_moving_truck } from "../../lib/estilo_sitio"
import { formatoMoneda } from "../../lib/helpers/main"

const ListadoDisponibilidadRecursos = (props)=> {
    const {
        condicion_default,
        showCustomFieldsData,
        hideSearch,
        showFilters,
        showSelection,
        exclude,
        hideActions,
        componentAction,
        loadingActions,
        typeView,
        hideColumns,
        hideExcelButton,
        condicion_filtro_meta,
        condicion_filtro,
        id_orden_gestion,
        autoSearch
    } = props
    const dispatch = useDispatch()
    const [ loadingSolicitud, setLoadingSolicitud ] = useState(false)
    const default_condicion_meta = condicion_filtro_meta ? condicion_filtro_meta : {}
    const default_filtro = condicion_filtro ? condicion_filtro : { incluir_flota_externa: true }
    const sesion                    = useSelector(state => state.miusuario)
    const [conductores, setConductores] = useState([])
    const [deleting, setDeleting]   = useState(false)
    const [ vehiculoSeleccionado, setVehiculoSeleccionado ] = useState(false)
    const [ loadingExcel, setLoadingExcel ] = useState(false)
    const [loadingConductores, setLoadingConductores] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const [ pagina, setPagina ]     = useState(1)
    const [ keyCollapse, setKeyCollapse ] = useState([1])
    const [ campoBusqueda, setCampoBusqueda ] = useState('')
    const [ total, setTotal ]       = useState(0)
    const [ condicion_busqueda, setCondicionBusqueda ] = useState(condicion_default ? condicion_default : {})
    const pais                      = useSelector(state => state.pais)
    const [ showFilterBox, setShowFilterBox ] = useState(false)
    const session                   = useSelector(state => state.miusuario)
    const interfaz_usuario          = useSelector(state => state.interfaz)
    const idioma                    = useSelector(state => state.idioma)
    const [ vehiculos, setVehiculos ] = useState([])
    const [ showModalVehiculo, setShowModalVehiculo ] = useState(false)
    const trash                     = props.trash ? props.trash : false
    const tipo                      = props.tipo ? props.tipo : "link"
    const titulo                    = props.title ? props.title : 'registros'
    const [ filtroBusqueda, setFiltroBusqueda ] = useState(default_filtro)
    const [ filtroBusquedaMetaData, setFiltroBusquedaMetaData ] = useState(default_condicion_meta)
    const key_interfaz              = 'tabla_disponibilidades'
    const key_esquema               = 'DISPONIBILIDAD'
    const module                    = modulo
    const [ key_input_filter, setKeyInputFilter ] = useState(0)
    const collapseRef = useRef(null);

    const solicitarGestion = async () => {
        // ids_origin
        // ids_destination
        let requeridos = [
            { value: "ids_origin._id", label: "Localidad de origen" },
            { value: "ids_destination._id", label: "Localidad de destino" },
        ]
        let faltantes = []
        requeridos.map(field => {
            if(!filtroBusqueda[field.value]) faltantes.push(field.label)
            return true
        })
        if(faltantes.length > 0) return messageApi.error(`Faltan campos: ${faltantes.join(', ')}`) 

        setLoadingSolicitud(true)
        return fetch(`${data.urlapi}/disponibilidades/solicitud`,{
            method:'POST',
            body: JSON.stringify({
                id_orden_gestion,
                id_vehiculo: vehiculoSeleccionado._id,
                ids_origin: filtroBusquedaMetaData["ids_origin._id"],
                ids_destination: filtroBusquedaMetaData["ids_destination._id"],
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${sesion.tokenSession}`,
                'country': pais,
                'lang': idioma
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                messageApi.error('Sin datos')
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
            } else if(res._id){
                messageApi.success("Solicitud enviada exitosamente")
                setTimeout(() => {
                    return window.location = `${rutas.solicitud_disponibilidad.slug}/?id=${res._id}`
                }, 1000);
            }
            return setLoadingSolicitud(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoadingSolicitud(false)
        })
    }

    const toggleCollapse = () => {
        setKeyCollapse([])
    }

    const obtenerRegistros = async (page, query)=>{
        let requeridos = [
            // { value: "ids_origin._id", label: "Localidad de origen" },
            // { value: "ids_destination._id", label: "Localidad de destino" },
        ]
        let faltantes = []
        requeridos.map(field => {
            if(!filtroBusqueda[field.value]) faltantes.push(field.label)
            return true
        })
        if(faltantes.length > 0) return messageApi.error(`Faltan campos: ${faltantes.join(', ')}`) 
        toggleCollapse()
        setLoadingConductores(true)
        if(query) if(trash === true) query.status = 'trash'
        const condicion = query ? query : condicion_busqueda
        return fetch(`${urlapi}/${module}/list`,{
            method:'POST',
            body: JSON.stringify({
                condicion,
                pagina: page
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${sesion.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                messageApi.error('Sin datos')
                return setLoadingConductores(false)
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
                return setLoadingConductores(false)
            }
            if(Array.isArray(res.datos) !== false){
                
                setConductores(res.datos)
                setTotal(res.total)
                if(res.vehiculos) setVehiculos(res.vehiculos)
            }
            return setLoadingConductores(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoadingConductores(false)
        })
    }

    const eliminarRecurso = async (id) => {
        setDeleting(true)
        return fetch(`${urlapi}/${module}?id=${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer: ${sesion.tokenSession}`,
            'country': pais,
            'lang': idioma
          },
        })
          .then((res) => {
            if (res.status === 401) return dispatch(cerrarSesion());
            return res.json();
          })
          .then(async (res) => {
            if (!res) {
                messageApi.error("Sin datos obtenidos")
            } else if (res.errorMessage) {
                messageApi.error(res.errorMessage)
            } else if(res._id){
              messageApi.success("Eliminado exitosamente")
              obtenerRegistros(1, false)
            }
            return setDeleting(false)
          })
          .catch((error) => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setDeleting(false)
          })
      }
  

    useEffect(() => {
        if(autoSearch) refrescarBusqueda()
    }, [  ])

    const handleChangePagina = (e) => {
        setPagina(e)
        obtenerRegistros(e, condicion_busqueda)
    }

    const paginacion = (ciclo, total) => {
        const cantidad = Math.ceil(total / ciclo)
        if(!cantidad) return false
        return <div className="mb-3">
            <Title level={5} className="mt-0" >TOTAL <b style={{ fontWeight: "bold" }}>{total}</b></Title>
            <Pagination showSizeChanger={false} defaultCurrent={pagina} total={(cantidad*10)} onChange={handleChangePagina} />
        </div>
    }

    const deseleccionarTodos = (e) => {
        setConductores([...[], ...conductores.map(veh => { 
            if(exclude){
                if( Array.isArray(exclude) !== false ){
                    if(exclude.includes(veh._id)) return veh
                }
            }
            veh.seleccionado = e.target.checked
            return veh 
        })])
      }

      const checkForEnabledValue = (id) => {
        if(exclude){
            if( Array.isArray(exclude) !== false ){
                if(exclude.includes(id)) return true
            }
        }
        return false
      }

      const handleChangeSeleccion = (e) => {
        const { name } = e.target
        const valor = e.target.checked
        const i = conductores.findIndex(ve => ve._id === name )
        conductores[i].seleccionado = valor
        setConductores([...[], ...conductores])
      }

      const validarChecked = (seleccionado, id) => {
        if(seleccionado === true) return true
        if(exclude){
            if( Array.isArray(exclude) !== false ){
                if(exclude.includes(id)) return true
            }
        }
        return false
      }

    const seleccionarRegistro = (data, action) => {
        deseleccionarTodos({ target: false })
        let datos = data
        if(Array.isArray(datos) !== true) datos = [data]
        if(props.onSelect) props.onSelect(datos, action)
    }

    const seleccionarEspecial = (action) => {
        return seleccionarRegistro(conductores.filter(veh => veh.seleccionado === true), action)
      }

      const accionButtons = () => {
        if(showSelection !== true) return false
        const seleccionados = conductores.filter(veh => veh.seleccionado === true).length
        const enable = seleccionados > 0 ? false : true

        if(componentAction){
            return <div style={{ marginTop: 10, marginBottom: 10 }} onClick={() => seleccionarRegistro(conductores.filter(veh => veh.seleccionado === true))}>
                {componentAction.map(it => {
                    return <Button disabled={enable} loading={ loadingActions === true } size="small" style={{ marginRight: 10 }} onClick={() => seleccionarEspecial(it.label)} >{it.label}</Button>
                })}
            </div>
        }

        return <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Row gutter={15}>
                <Col span="auto"><Button disabled={enable} size="small" onClick={() => seleccionarRegistro(conductores.filter(veh => veh.seleccionado === true))}>SELECCIONAR</Button></Col>
                <Col span="auto"><Title level={5} className="mt-0 mb-0"><PiCursorClickFill /> Toca el título para seleccionar uno</Title></Col>
            </Row>
        </div>
      }

      const showByType = (tipo, data) => {
        switch (tipo) {
            case "funcion":
                return <b className="hover" onClick={() => seleccionarRegistro(data)}>{data.titulo ? data.titulo : 'SIN INFORMACIÓN'}</b>
            default:
                return data.titulo
        }
    }

    const onSelectConductor = (data) => {
        let item = null
        if(Array.isArray(data)) if(data.length > 0) item = data[0]
        if(!item) return 
        setVehiculoSeleccionado(item)
        return setShowModalVehiculo(true)
    }

    const showTable = (registros) => {
        const component_titulo = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="titulo" />} render={(data) => {
            return <div>{showByType(typeView, data)}
            </div>
        }} />

        const component_tipo_disponibilidad = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="tipo_disponibilidad" />} render={(data) => {
            return <div>{data.tipo_disponibilidad}</div>
        }} />
        const component_ids_origin = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="ids_origin" />} render={(data) => {
            return <div>{data.ids_origin.map(e => e.titulo).join(', ')}</div>
        }} />
        
        const component_ids_destination = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="ids_destination" />} render={(data) => {
            return <div>{data.ids_destination.map(e => e.titulo).join(', ')}</div>
        }} />
        
        const component_carga = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="carga" />} render={(data) => {
            return <div>
                <Title level={5} className="mt-0 mb-0">Desde</Title>
                {formatYMD_UTC(data.fecha_carga_desde)} <Tag>{fechaUTCATiempo(data.fecha_carga_desde)}</Tag>
                <Title level={5} className="mt-0 mb-0">Hasta</Title>
                {formatYMD_UTC(data.fecha_carga_hasta)} <Tag>{fechaUTCATiempo(data.fecha_carga_hasta)}</Tag>
            </div>
        }} />
        const component_descarga = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="descarga" />} render={(data) => {
            return <div>
                <Title level={5} className="mt-0 mb-0">Desde</Title>
                {formatYMD_UTC(data.fecha_descarga_desde)} <Tag>{fechaUTCATiempo(data.fecha_descarga_desde)}</Tag>
                <Title level={5} className="mt-0 mb-0">Hasta</Title>
                {formatYMD_UTC(data.fecha_descarga_hasta)} <Tag>{fechaUTCATiempo(data.fecha_descarga_hasta)}</Tag>
                </div>
        }} />
        const component_vencimiento = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="vencimiento" />} render={(data) => {
            return <div>{data.vencimiento ? fechaATextoSimple(data.vencimiento) : <TagSinDatos /> }</div>
        }} />
        
        const component_creador = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="creador" />} render={(data) => {
            return <div>{data.usuario?.nombres} {data.usuario?.apellidos}</div>
        }} />
        const component_fecha = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="createdAt" />} render={(data) => {
            return <div>{fechaATextoSimple(data.createdAt)}</div>
        }} />

        const acciones_botones = <Column title="Acciones" fixed="right" ellipsis render={(data) => {
            return <div>
                <VerContactoRapido id_registro={data._id} onCreate={() => obtenerRegistros(1, false)} />
          </div>
        }} />

        
        return <div>
        {paginacion(data.pagina, total)}
        {accionButtons()}
        <Table dataSource={registros} pagination={false} size="small" scroll={estilo_moving_truck.scroll_row} bordered locale={{ emptyText: <HelperModal tipo="disponibilidades" /> }} >
            {/* { encontrarLlaveValorEnEsquema("titulo", interfaz_usuario[ key_interfaz ]) === false ? false : component_titulo } */}
            {/* { encontrarLlaveValorEnEsquema("tipo_disponibilidad", interfaz_usuario[ key_interfaz ]) === false ? false : component_tipo_disponibilidad } */}
            { encontrarLlaveValorEnEsquema("ids_origin", interfaz_usuario[ key_interfaz ]) === false ? false : component_ids_origin }
            { encontrarLlaveValorEnEsquema("ids_destination", interfaz_usuario[ key_interfaz ]) === false ? false : component_ids_destination }
            { encontrarLlaveValorEnEsquema("carga", interfaz_usuario[ key_interfaz ]) === false ? false : component_carga }
            { encontrarLlaveValorEnEsquema("descarga", interfaz_usuario[ key_interfaz ]) === false ? false : component_descarga }
            { encontrarLlaveValorEnEsquema("vencimiento", interfaz_usuario[ key_interfaz ]) === false ? false : component_vencimiento }
            {/* { encontrarLlaveValorEnEsquema("createdAt", interfaz_usuario[ key_interfaz ]) === false ? false : component_fecha } */}
            {/* { encontrarLlaveValorEnEsquema("creador", interfaz_usuario[ key_interfaz ]) === false ? false : component_creador } */}
            {/* { hideActions === true ? false : acciones_botones } */}
            
        </Table>
    </div>
    }

    const mostrarRegistros = (records) => {
        const registros = records ? records : conductores
        if(loadingConductores) return <CargandoTabla />
        if(registros.length < 1) return <HelperModal tipo="disponibilidad-recursos" />

        const component_titulo = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="titulo" />} render={(data) => {
            return <div>{showByType(typeView, data)}
            <VerContactoRapido id_registro={data._id} onCreate={() => obtenerRegistros(1, false)} />
            </div>
        }} />

        const component_tipo_disponibilidad = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="tipo_disponibilidad" />} render={(data) => {
            return <div>{data.tipo_disponibilidad}</div>
        }} />
        const component_ids_origin = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="ids_origin" />} render={(data) => {
            return <div>{data.ids_origin.map(e => e.titulo).join(', ')}</div>
        }} />
        
        const component_ids_destination = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="ids_destination" />} render={(data) => {
            return <div>{data.ids_destination.map(e => e.titulo).join(', ')}</div>
        }} />
        
        const component_carga = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="carga" />} render={(data) => {
            return <div>
                <Title level={5} className="mt-0 mb-0">Desde</Title>
                {formatYMD_UTC(data.fecha_carga_desde)} <Tag>{fechaUTCATiempo(data.fecha_carga_desde)}</Tag>
                <Title level={5} className="mt-0 mb-0">Hasta</Title>
                {formatYMD_UTC(data.fecha_carga_hasta)} <Tag>{fechaUTCATiempo(data.fecha_carga_hasta)}</Tag>
            </div>
        }} />
        const component_descarga = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="descarga" />} render={(data) => {
            return <div>
                <Title level={5} className="mt-0 mb-0">Desde</Title>
                {formatYMD_UTC(data.fecha_descarga_desde)} <Tag>{fechaUTCATiempo(data.fecha_descarga_desde)}</Tag>
                <Title level={5} className="mt-0 mb-0">Hasta</Title>
                {formatYMD_UTC(data.fecha_descarga_hasta)} <Tag>{fechaUTCATiempo(data.fecha_descarga_hasta)}</Tag>
                </div>
        }} />
        const component_vencimiento = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="vencimiento" />} render={(data) => {
            return <div>{data.vencimiento ? fechaATextoSimple(data.vencimiento) : <TagSinDatos /> }</div>
        }} />
        
        const component_creador = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="creador" />} render={(data) => {
            return <div>{data.usuario?.nombres} {data.usuario?.apellidos}</div>
        }} />
        const component_fecha = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="createdAt" />} render={(data) => {
            return <div>{fechaATextoSimple(data.createdAt)}</div>
        }} />

        const component_precio = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="precio" />} render={(data) => {
            return <div>{ data.precio_referencial ? <div>{data.moneda} {data.precio_referencial}</div> : false }</div>
        }} />
        const component_anticipacion = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="anticipacion" />} render={(data) => {
            return <div>{formatoMoneda(data.anticipacion)}</div>
        }} />

        const acciones_botones = <Column title="Acciones" fixed="right" ellipsis render={(data) => {
            return <div>
                <VerContactoRapido id_registro={data._id} onCreate={() => obtenerRegistros(1, false)} />
          </div>
        }} />

        const listado = <div>
        {paginacion(data.pagina, total)}
        {accionButtons()}
        <Table dataSource={registros} pagination={false} size="small"  bordered scroll={{ x:"100vw" }} locale={{ emptyText: <HelperModal tipo="disponibilidades" /> }} >
        {
        showSelection !== true ? false : <Column title={<Checkbox onChange={deseleccionarTodos} />} render={(data) => {
            return <Checkbox disabled={checkForEnabledValue(data._id)} checked={validarChecked(data.seleccionado, data._id)} name={data._id} onChange={handleChangeSeleccion}/>
        }} />
        }
            { encontrarLlaveValorEnEsquema("titulo", interfaz_usuario[ key_interfaz ]) === false ? false : component_titulo }
            { encontrarLlaveValorEnEsquema("tipo_disponibilidad", interfaz_usuario[ key_interfaz ]) === false ? false : component_tipo_disponibilidad }
            { encontrarLlaveValorEnEsquema("precio", interfaz_usuario[ key_interfaz ]) === false ? false : component_precio }
            { encontrarLlaveValorEnEsquema("anticipacion", interfaz_usuario[ key_interfaz ]) === false ? false : component_anticipacion }
            { encontrarLlaveValorEnEsquema("ids_origin", interfaz_usuario[ key_interfaz ]) === false ? false : component_ids_origin }
            { encontrarLlaveValorEnEsquema("ids_destination", interfaz_usuario[ key_interfaz ]) === false ? false : component_ids_destination }
            { encontrarLlaveValorEnEsquema("carga", interfaz_usuario[ key_interfaz ]) === false ? false : component_carga }
            { encontrarLlaveValorEnEsquema("descarga", interfaz_usuario[ key_interfaz ]) === false ? false : component_descarga }
            { encontrarLlaveValorEnEsquema("vencimiento", interfaz_usuario[ key_interfaz ]) === false ? false : component_vencimiento }
            { encontrarLlaveValorEnEsquema("createdAt", interfaz_usuario[ key_interfaz ]) === false ? false : component_fecha }
            { encontrarLlaveValorEnEsquema("creador", interfaz_usuario[ key_interfaz ]) === false ? false : component_creador }
            {/* { hideActions === true ? false : acciones_botones } */}
            
        </Table>
    </div>

    const iterar_agregar_conductores = registros.map(reg => {
        const vehiculos_correspondientes = vehiculos.filter(veh => reg.ids_vehiculos.includes(veh._id) )
        reg.vehiculos = vehiculos_correspondientes
        return reg
    })
    const ids_vehiculos = vehiculos.map(veh => veh._id)
    const items_resultados = [
        {
            label: <div><Title level={4} className="mt-0 mb-0" ><FaTruckFront style={{ verticalAlign: "middle" }} /> VER VEHÍCULOS</Title> </div>,
            children: <ListadoVehiculos hideSearch={true} extra_columns={['empresa']} stopRefresh={true} onSelect={(data => onSelectConductor(data))} typeView="funcion" condicion_default={{ _id: { $in: ids_vehiculos }, allow_externals: true }} />
        },
        {
            label: <div><Title level={4} className="mt-0 mb-0" ><FaRegCalendarAlt style={{ verticalAlign: "middle" }} /> VER AGENDAMIENTOS</Title> </div>,
            children: listado
        },
        {
            label: <div><Title level={4} className="mt-0 mb-0" ><FaRegCalendar style={{ verticalAlign: "middle" }} /> VER CALENDARIO</Title> </div>,
            children: <div><AgendaDisponibilidad data={iterar_agregar_conductores} /> </div>
        }
    ].map((item,i) => ({ ...item, key: (i+1) }) )

    return <div>
        {modalVehiculo()}
        <Tabs defaultActiveKey={1} items={items_resultados} />
    </div>
    }

    const handleSubmit = (e) => {
        if(e) e.preventDefault()
        if (!campoBusqueda){
            setCondicionBusqueda(condicion_default);
            setPagina(1);
            return obtenerRegistros(1, condicion_default);
        }
        const condicion = {
            ...condicion_default,
          $text: { $search: campoBusqueda.toLowerCase() }
        };
        setCondicionBusqueda(condicion);
        setPagina(1);
        return obtenerRegistros(1, condicion);
      };

    const handleChangeCampo = (e) => {
        const { value } = e.target;
        return setCampoBusqueda(value);
      };

    const buscador = () => {
        if(hideSearch === true) return false
        return <Col span="auto"><Form onSubmitCapture={handleSubmit}>
                    <Row gutter={15}>
                        <Col md={14}>
                            <Form.Item label="Buscar">
                                <Input allowClear defaultValue={campoBusqueda} onChange={handleChangeCampo} placeholder={`Buscar por palabras clave`} />
                            </Form.Item>
                        </Col>
                        <Col md={10}>
                            <Form.Item>
                                <Button onClick={handleSubmit} style={{ width: "100%"}}><SearchOutlined /> BUSCAR</Button>
                            </Form.Item>
                        </Col>
                    </Row>
            </Form>
        </Col>
      }

      const agregarFiltroFecha = (key, value) => {
        setFiltroBusqueda(prev => {
            let actual = {...prev}
            if(value){
                actual[key] = DateTime.fromISO(value).toUTC().toISO()
            } else {
                delete actual[key]
            }
            return actual
        })
      }

      const prepararDatosAgenda = (datos) => {
        let vehicles = []
        
      }

      const visualizarEmpresa = (vehiculo) => {
        return <div>
            <Row gutter={15}>
                <Col md={8}>
                    <Title level={5} className="mt-0 mb-0">Razón social</Title>
                    <Tag>{vehiculo?.empresa?.razon_social}</Tag>
                </Col>
                <Col md={4}>
                    <Title level={5} className="mt-0 mb-0">RUT</Title>
                    <Tag>{vehiculo?.empresa?.rut}</Tag>
                </Col>
                <Col md={8}>
                    <Title level={5} className="mt-0 mb-0">Dirección fiscal</Title>
                    <Tag>{vehiculo?.empresa?.direccion}</Tag>
                </Col>
            </Row>
        </div>
      }

      const visualizarVehiculo = (vehiculo) => {
        return <div>
            <Row gutter={15}>
                <Col md={4}>
                    <Title level={5} className="mt-0 mb-0">Marca</Title>
                    <Tag>{vehiculo.marca}</Tag>
                </Col>
                <Col md={4}>
                    <Title level={5} className="mt-0 mb-0">Modelo</Title>
                    <Tag>{vehiculo.modelo}</Tag>
                </Col>
                <Col md={4}>
                    <Title level={5} className="mt-0 mb-0">Año</Title>
                    <Tag>{vehiculo.ano}</Tag>
                </Col>
                <Col md={4}>
                    <Title level={5} className="mt-0 mb-0">Tipo de vehículo</Title>
                    <Tag>{vehiculo.tipo}</Tag>
                </Col>
                <Col md={4}>
                    <Title level={5} className="mt-0 mb-0">Patente</Title>
                    <Tag>{vehiculo.patente}</Tag>
                </Col>
            </Row>
            <ListadoCalificaciones showFilters={false} hideSearch={true} condicion_default={{ id_vehiculo: vehiculo._id }} />
        </div>
      }

      const accionesVehiculo = () => {
        if(!id_orden_gestion) return false
        return <div>
                <Popconfirm
                    title="¿Deseas continuar?"
                    description="Asegúrate que todos los datos de esta orden están completos y correctos antes de solicitar la gestión"
                    onConfirm={() => solicitarGestion()}
                    onCancel={() => false}
                    okText="CONFIRMAR"
                    cancelText="CANCELAR"
                  >
                  <Button loading={loadingSolicitud} size="small" type="primary" success icon={<IoIosSend style={{ verticalAlign: "middle" }} />} > SOLICITAR GESTIÓN</Button>
                </Popconfirm>
        </div>
      }

      const modalVehiculo = () => {

        const id_vehiculo       = vehiculoSeleccionado?._id
        if(!id_vehiculo) return false
        const filtrado          = conductores.filter(veh => veh.ids_vehiculos.includes(id_vehiculo) )
        const datos_agenda      = prepararDatosAgenda(filtrado)
        const listado           = <div>{showTable(filtrado)}</div>
        let titulo = vehiculoSeleccionado?.marca
        if(vehiculoSeleccionado.modelo) titulo += ` ${vehiculoSeleccionado.modelo}`
        if(vehiculoSeleccionado.detalle_tipo_motor) titulo += ` ${vehiculoSeleccionado.detalle_tipo_motor}`

        let items_ = [
            {
                label: <div><Title level={4} className="mt-0 mb-0" ><FaRegCalendarAlt style={{ verticalAlign: "middle" }} /> DETALLES DEL VEHÍCULO</Title> </div>,
                children: visualizarVehiculo(vehiculoSeleccionado)
            },
            {
                label: <div><Title level={4} className="mt-0 mb-0" ><FaRegCalendarAlt style={{ verticalAlign: "middle" }} /> DETALLES DE LA EMPRESA</Title> </div>,
                children: visualizarEmpresa(vehiculoSeleccionado)
            },
            {
                label: <div><Title level={4} className="mt-0 mb-0" ><FaRegCalendarAlt style={{ verticalAlign: "middle" }} /> VER AGENDA</Title> </div>,
                children: <AgendaDisponibilidad stopPropagation={true} data={filtrado} />
            }
        ].map((item,i) => ({ ...item, key: (i+1) }) )

        return <Modal
                width="80%"
                title={`Detalles del ${titulo}`}
                open={showModalVehiculo} 
                // onOk={handleOk} 
                onCancel={() => {
                    setVehiculoSeleccionado(false)
                    setShowModalVehiculo(false)
                }}
                // confirmLoading={loading}
                footer={[]}
            >
            <Title level={3} className="mt-0 mb-0">¡El vehículo {titulo} <b style={{ color: "green" }}>está disponible! <FaCheckCircle style={{ verticalAlign: "middle" }} /></b></Title>
            {accionesVehiculo()}
            <Tabs defaultActiveKey={1} items={items_} />
        </Modal>
      }

      const agregarFiltro = (key, value) => {

        let previas = []
        let values = []
        if(key === "ids_origin._id"){
            
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]
            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                let nuevos_items = []
                for( const val of value ){
                    const i = actual[key].findIndex(it => it._id === val._id)
                    if(i < 0) nuevos_items.push(val)
                }
                actual[key] = [ ...actual[key], ...nuevos_items ]
                return actual
            })

        } else if( key === "ids_destination._id" ){
            
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]

            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                let nuevos_items = []
                for( const val of value ){
                    const i = actual[key].findIndex(it => it._id === val._id)
                    if(i < 0) nuevos_items.push(val)
                }
                actual[key] = [ ...actual[key], ...nuevos_items ]
                return actual
            })

        } else if( key === "ids_vehiculos"){
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]

            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                let nuevos_items = []
                for( const val of value ){
                    const i = actual[key].findIndex(it => it._id === val._id)
                    if(i < 0) nuevos_items.push(val)
                }
                actual[key] = [ ...actual[key], ...nuevos_items ]
                return actual
            })
        } else if( key === "tipos_vehiculo"){
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]

            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                let nuevos_items = []
                for( const val of value ){
                    const i = actual[key].findIndex(it => it._id === val._id)
                    if(i < 0) nuevos_items.push(({ ...val, titulo: val.tipo }))
                }
                actual[key] = [ ...actual[key], ...nuevos_items ]
                return actual
            })
        } else if( key === "requisito_conductor" ){

            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]
            console.log(values)
            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                let nuevos_items = []
                for( const val of value ){
                    const i = actual[key].findIndex(it => it._id === val._id)
                    if(i < 0) nuevos_items.push(val)
                }
                actual[key] = [ ...actual[key], ...nuevos_items ]
                return actual
            })

        } else if( key === "requisito_vehiculo" ){

            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]
            console.log(values)
            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                let nuevos_items = []
                for( const val of value ){
                    const i = actual[key].findIndex(it => it._id === val._id)
                    if(i < 0) nuevos_items.push(val)
                }
                actual[key] = [ ...actual[key], ...nuevos_items ]
                return actual
            })

        } else {
            if(Array.isArray(value)){
                values = { $in: value.map(v => v._id ? v._id : v) }
            } else {
                values = value
            }
        }
        setFiltroBusqueda(prev => {
            let actual = {...prev}
            actual[key] = values
            return actual
        })
      }

      const refrescarBusqueda = () => {
        setPagina(1)
        let cond = {}
        Object.keys(filtroBusqueda).map(llave => {
            if(filtroBusqueda[llave]['$in']){
                if(Array.isArray(filtroBusqueda[llave]['$in']) !== false){
                    if(filtroBusqueda[llave]['$in'].length > 0) cond[llave] = filtroBusqueda[llave]
                }
            } else if(Array.isArray(filtroBusqueda[llave]) !== false){
                if(filtroBusqueda[llave].length > 0){
                    cond[llave] = { $in: filtroBusqueda[llave] }
                }
            } else {
                cond[llave] = filtroBusqueda[llave]
            }
        })
        obtenerRegistros(1, cond)
    }

    const removerFiltro = (key, value) => {
        setFiltroBusqueda(prev => {
            let actual  = {...prev}
            actual[key] = actual[key].filter(id => id !== value)
            if( actual[key] ) if(actual[key].length < 1) delete actual[key]
            return actual
        })
        setFiltroBusquedaMetaData(prev => {
            let actual  = {...prev}
            actual[key] = actual[key].filter(v => v._id !== value)
            return actual
        })
    }
    
    const removerZonas = (key) => {
        setFiltroBusqueda(prev => {
            let actual  = {...prev}
            delete actual[key]
            return actual
        })
        setFiltroBusquedaMetaData(prev => {
            let actual  = {...prev}
            actual[key] = []
            return actual
        })
    }

    const handleChangeCollapse = (e) => {
        setKeyCollapse(e)
    }

    const resetFilters = () => {
        setFiltroBusquedaMetaData({})
        setFiltroBusqueda({})
        setKeyInputFilter(key_input_filter + 1)
        obtenerRegistros(1, condicion_default ? condicion_default : {})
    }
    
      const mostrarDatosPersonalizados = () => {
        const component = <GraficosCamposPersonalizados typeView="modaxl" tipo="contacto" />
        return showCustomFieldsData === true ? <Col><ModalPersonalizado typeView="modal" slug="informe_personalizado" component={component} /></Col> : false
      }

      const mostrarFiltros = () => {
        const tipos_vehiculos_seleccionados             = []
        const boton_requisito                           = <Button style={{ width: "100%" }} icon={<GrAdd /> } className="mb-3" >REQUISITO VEHÍCULO</Button>
        const boton_requisito_conductor                 = <Button style={{ width: "100%" }} icon={<GrAdd /> } className="mb-3" >REQUISITO CONDUCTOR</Button>

        const mostrarButtonReset                        = Object.keys(filtroBusqueda).length > 0 ? true : false

            
        const content = <div>

            <Row gutter={15}>
                {/* <Col md={6}>
                    <div className="mt-2"><SelectorClientes key={key_input_filter} titulo="Cliente" condicion={{ }} onChange={(data) => agregarFiltro('id_cliente', [{ _id: data.value }])} /></div>
                </Col>
                  */}
                <Col md={6}>
                    <Title className="mt-0" level={5}>Localidad de carga</Title>
                    <SelectorZonaAvanzadoInternacional titleLabel="AGREGAR " onSelected={(data) => agregarFiltro('ids_origin._id', [data])} />
                    
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Localidad de descarga</Title>
                    <SelectorZonaAvanzadoInternacional titleLabel="AGREGAR " onSelected={(data) => agregarFiltro('ids_destination._id', [data])} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Fecha de carga</Title>
                    <Input type="date" key={`fecha_carga-${key_input_filter}`} onChange={(e) => agregarFiltroFecha("fecha_carga", e.target.value)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Fecha de descarga</Title>
                    <Input type="date" key={`fecha_descarga-${key_input_filter}`} onChange={(e) => agregarFiltroFecha("fecha_descarga", e.target.value)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Vehículos</Title>
                    <ModalSeleccionVehiculo label="AGREGAR" style={{ width: "100%" }} isMulti={true} showSelection={true} hideSeleccionados={true}  onSelect={data => agregarFiltro('ids_vehiculos', data)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Tipo de vehículo</Title>
                    <ModalSeleccionTiposVehiculos title="AGREGAR" style={{ width: "100%" }} exclude={tipos_vehiculos_seleccionados} showSelection={false} hideSeleccionados={true} onSelect={(data) => agregarFiltro('tipos_vehiculo', data)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Requisito de vehículo</Title>
                    <ModalSeleccionRequisitos boton={boton_requisito} slug="AGREGAR" typeView="modal" onSelect={(data) => agregarFiltro('requisito_vehiculo', [data])} condicion_busqueda={{ tipo: "vehiculo", status: "active" }} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Requisito de conductor</Title>
                    <ModalSeleccionRequisitos boton={boton_requisito_conductor} slug="AGREGAR" typeView="modal" onSelect={(data) => agregarFiltro('requisito_conductor', [data])} condicion_busqueda={{ tipo: "conductor", status: "active" }} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Cantidad de viajes mínimos</Title>
                    <Input type="number" key={`cantidad-${key_input_filter}`} onChange={(e) => agregarFiltro("cantidad_viajes", e.target.value)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Rating mínimo de conductor</Title>
                    <Rate key={`rating-${key_input_filter}`} value={filtroBusqueda.rating ? filtroBusqueda.rating : null} onChange={(e) => agregarFiltro("rating", e)} /> { filtroBusqueda.rating ? <FaRegTrashAlt size={15} style={{ verticalAlign: "middle" }} className="hover" onClick={() => {
                        setFiltroBusqueda(prev => {
                            let actual = {...prev}
                            delete actual.rating
                            return actual
                        })
                    }} /> : false }    
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Incluir flota externa</Title>
                    <Form.Item label="" className="mb-2" required>
                        <Switch checkedChildren="INCLUIR FLOTA EXTERNA" unCheckedChildren="SOLO MI FLOTA" defaultChecked={filtroBusqueda?.incluir_flota_externa === true } onChange={(e) => agregarFiltro('incluir_flota_externa',e)} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={15}>
                <Col xs={24} className="mt-3">
                    <Row gutter={15}>
                    {mostrarMetaDataFiltros('ids_origin._id',  'Zona de carga')}
                    {mostrarMetaDataFiltros('ids_destination._id',  'Zona de descarga')}
                    {mostrarMetaDataFiltros('ids_vehiculos',  'Vehículos')}
                    {mostrarMetaDataFiltros('tipos_vehiculo',  'Tipos de vehículos')}
                    {mostrarMetaDataFiltros('requisito_vehiculo',  'Requisito de vehículos')}
                    {mostrarMetaDataFiltros('requisito_conductor',  'Requisito de conductor')}
                    </Row>
                </Col> 
            </Row>

            <Row gutter={15}>
                <Col md={3}>
                    <Button loading={loadingConductores} type="primary" onClick={() => refrescarBusqueda()} style={{ width: "100%" }}  >BUSCAR</Button>
                </Col>
                <Col md={3}>
                    <Button disabled={!mostrarButtonReset}  style={{ width: "100%" }} onClick={() => resetFilters()}>LIMPIAR</Button>
                </Col>
            </Row>
        </div>

        return <div>
            <Collapse  className="mb-3" items={[
                {
                    key: 1,
                    label: <Title className="mt-0 mb-0" level={5}>Filtros de búsqueda</Title>,
                    children: content
                }
            ]} activeKey={keyCollapse} onChange={handleChangeCollapse} />
        </div>
      }

      const mostrarFiltrosBusqueda = () => {


        return <div style={{ marginBottom: 20 }} className="mt-0">
            {mostrarFiltros()}
        </div>
      }

      const mostrarMetaDataFiltros = (key, title) => {
        if(!filtroBusquedaMetaData[key]) return false
        if(!["ids_origin._id","ids_destination._id","ids_vehiculos","tipos_vehiculo","requisito_conductor","requisito_vehiculo"].includes(key) ) return false

            if(filtroBusquedaMetaData[key].length < 1) return false
            return <Col md={8} className="mb-3">
                <Title level={5} className="mt-0 mb-0">{title}</Title>
                {
                    filtroBusquedaMetaData[key].map((e, i) => <Tag color="geekblue" style={{ marginRight: 10 }} className="mt-0 mb-0" key={`${e._id}.${i}`}>{e.titulo}  <IoCloseSharp className="hover" onClick={() => removerFiltro(key, e._id)} /></Tag> )
                }
                <Button size="small" style={{ color: "red" }} type="link" icon={<FaRegTrashAlt />} onClick={() => removerZonas(key)} >REMOVER TODO</Button>
            </Col>
        
      }

      const encabezado = () => {
        return <div>
            <Row gutter={15}>
            {/* {buscador()} */}
            {/* { hideColumns === true ? false : <Col span="auto"><PersonalizarColumnas key_interfaz={key_interfaz} key_esquema={key_esquema} /></Col> } */}
            {/* { hideExcelButton === true ? false : <Col span="auto"><Button loading={loadingExcel} style={{ marginRight: 10, marginBottom: 15 }} color="green"  onClick={() => descargarExcel()}><FileExcelFilled /> EXPORTAR</Button></Col> } */}
        </Row>
        </div>
      }

      const render = <div>
        {encabezado()}
        <Row gutter={15}>
        {mostrarDatosPersonalizados()}
        </Row>
        {mostrarRegistros()}
      </div>

    return <div>
        {contextHolder}
        
        {
                showFilters === true ? <Row gutter={15}>
                <Col md={24}>
                    {mostrarFiltrosBusqueda()}
                </Col>
                <Col md={24}>{render}</Col>
            </Row> : <div>{render}</div>
        }
    </div>
}
export default ListadoDisponibilidadRecursos